import React, { useEffect } from "react";
import Slider from "../../components/shared/Slider";
import PageSEO from "../../components/shared/PageSEO";
import AboutUsSection from "./components/AboutUsSection";
import ServicesSection from "./components/ServicesSection";
import NewsSection from "./components/NewsSection";
import "./Home.scss";
import { DgaCard } from "platformscode-new-react";
import CardWrapper from "./CardWrapper";
import "aos/dist/aos.css";
import Quote from "./components/Quote";
import EventsSection from "./components/EventsSection";
const separator = "assets2/imges/separator.svg";
const hajPattern = "/assets2/imges/haj-pattern.svg";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageSEO
        title="الرئيسية"
        description="أمانة العاصمة المقدسة — نسعى في تقديم خدمات بلدية راقية لساكني أم القرى وقاصديها. تصفح الخدمات الإلكترونية، الأخبار، والمشاريع."
      />
      <Slider />
      <div className="">
        <AboutUsSection />
        <Quote />
        <img src={hajPattern} alt="" aria-hidden="true" className="w-full" loading="lazy" decoding="async" width="1280" height="21" style={{ aspectRatio: '1280/21' }} />
        <NewsSection />
        <EventsSection />
        <ServicesSection />
      </div>
    </>
  );
}

export default Home;
